import type { TooltipProps } from './tooltip.types'

import Box from '../box'
import { bg, borderRadius, boxShadow } from './consts'

export const TooltipContent = ({
  children,
  disabled,
  fontSize = '16px',
  maxWidth = '400px',
  minWidth,
  whiteSpace = 'pre-wrap',
  wordBreak = 'break-word',
}: TooltipProps) => (
  <Box
    bg={disabled ? bg.disabled : bg.regular}
    borderRadius={borderRadius}
    boxShadow={boxShadow}
    className="vui-tooltip-content"
    color="white"
    display="block"
    fontSize={fontSize}
    minW={minWidth}
    maxW={maxWidth}
    overflowY="auto"
    py={1}
    px={2}
    whiteSpace={whiteSpace}
    wordBreak={wordBreak}
  >
    {children}
  </Box>
)

TooltipContent.displayName = 'TooltipContent'
